import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { LoadingController, ToastController } from '@ionic/angular';
import { HelperService } from '../../core/services/helper.service';
import { VendorBackendService } from '../../core/services/vendor-services/vendor-backend.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {

  forgotform = new UntypedFormGroup({});
  submitted: boolean = false;
  loading: boolean = false;
  emailSent: boolean=false;
  showSuccessMessage: boolean=false;
  msg = 'Please enter your email address. We will send you an email to reset your password';
  token: any;
  verifyemail: string;

  constructor(
    private fb: UntypedFormBuilder,
    private backendService: VendorBackendService,
    public helperService: HelperService,
    public toastController: ToastController,
    public loadingController: LoadingController) { }
    
  ngOnInit() {   
    this.forgotform = this.fb.group({
      'email': ['', [Validators.required, Validators.email]]
    }); 
  }

  get f() { return this.forgotform.controls; }

  onSubmitforgot() {
    if (this.forgotform.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    this.submitted = true;
    this.helperService.loader();
    let payload = {      
      email : this.forgotform.value.email
    }
    this.backendService.PostAPICall('forgotPassword', payload, this.token).subscribe(
      data => {
        this.helperService.closeLoader();
        // this.appRouter.gotoPath('login');
        this.showSuccessMessage=true; 
        this.msg = 'Password reset link has been sent successfully to your mail. Password reset link is valid for 30 mins.';
      },
      (error)=>{
        //console.log(error);
        this.helperService.closeLoader();
        this.helperService.handleError(error);
      }
    );   
  }   
}
